import React from 'react'
import { motion } from 'framer-motion'

const QuoteCard = ({ title, quote }) => {
  console.log("tite", title.split(' '));

  return (
    <motion.div
      className='my-7 text-start'
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {/* <h1 className='text-4xl font-bold'>{title.split(' ')[0]} <span className='text-transparent bg-clip-text bg-gradient-to-tr from-[#ED8B29] to-[#FFD23F]'>{title.split(' ')[1]}</span></h1> */}
      <h1 className='text-4xl font-bold'>{title}</h1>
      <div className="rounded-full bg-primaryColor w-fit group flex items-center justify-center sm:ms-auto sm:me-12 mx-auto mt-4 -mb-[74px] px-5 py-[21px] z-10 relative hover:text-white">
        <svg className='w-12 h-12 quote-svg' xmlns="http://www.w3.org/2000/svg" width="48" viewBox="0 0 16 14" fill="none" ><path d="M14.5 7H12V5C12 3.89688 12.8969 3 14 3H14.25C14.6656 3 15 2.66563 15 2.25V0.75C15 0.334375 14.6656 0 14.25 0H14C11.2375 0 9 2.2375 9 5V12.5C9 13.3281 9.67188 14 10.5 14H14.5C15.3281 14 16 13.3281 16 12.5V8.5C16 7.67188 15.3281 7 14.5 7ZM5.5 7H3V5C3 3.89688 3.89688 3 5 3H5.25C5.66563 3 6 2.66563 6 2.25V0.75C6 0.334375 5.66563 0 5.25 0H5C2.2375 0 0 2.2375 0 5V12.5C0 13.3281 0.671875 14 1.5 14H5.5C6.32812 14 7 13.3281 7 12.5V8.5C7 7.67188 6.32812 7 5.5 7Z" fill="currentColor"></path></svg>
      </div>
      <div className="border px-10 py-16 rounded-3xl mt-8">
        <p className='text-lg'>{quote}</p>
      </div>
    </motion.div>
  )
}

export default QuoteCard
